/* eslint-disable max-len */
/* eslint-disable max-len */
import React from 'react'
import calculatePercentage from '../../../../../CommonMethods/percentageCalculator'
import { Link } from 'react-router-dom'

export default function TableBody({item,searchParams,selectedRows,handleCheckboxChange, AYStatus, pageType}) {
    const rowId = pageType === "staff" ? (item?.employee_id) : item?.student_id;

    return (
        <>
            <tr>
                <td className="text-start">
                    <div className={`relative checkbox custom-checkBoxBlue1`}>
                        <input  type="checkbox" id={rowId} checked={selectedRows?.some((obj)=>obj.id=== rowId)} onChange={()=>handleCheckboxChange(rowId)}/>
                        <label htmlFor={rowId} className="text-sm font-normal text-[#031624] pl-3 w-full cursor-pointer"></label>
                    </div>
                </td>
                <td className="text-start">
                    {pageType === "staff" ? item?.employee_number : item?.student_id}
                </td>
                <td className="text-start"><span className='' title={pageType === "staff" ? item?.full_name : item?.student_name}>{pageType === "staff" ? item?.full_name : item?.student_name}</span></td>
                <td className="text-start">{pageType === "staff" ? item?.staff_type : item?.gender}</td>
                <td className="text-end border-l border-[#EDEDED] colspan">
                    <span>
                        {item?.total_days}
                    </span>
                </td>
                <td className="text-end colspan">
                    <span>
                        {item?.present_days}
                    </span>
                </td>
                <td className="text-end colspan">
                    <span>{calculatePercentage(item.present_days, item.total_days)}%</span>
                </td>
                <td className="text-end colspan">
                    <span>
                        {item?.absent_days}
                    </span>
                </td>
                <td className="border-l border-[#EDEDED]">
                    <div className='flex justify-center items-center'>
                        <Link to={pageType === "staff" ?  
                            `/employee-master/employee-attendance/view-attendance/${item.employee_number}/${item?.full_name}/${item?.employee_id}?${searchParams.toString()}`
                            :
                            `/student-master/student-attendance/view-attendance/${item.student_id}/${item?.student_name}?${searchParams.toString()}`} >
                            <button  className="list-actn-btn"type='button'>
                                <span id="view" className="">View</span>
                            </button>
                        </Link>
                    </div>

                </td>
                
                
            </tr>
        </>
    )
}
